// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sgV5","rootMobile":"styles_rootMobile__18SO3"};